import React from "react";
import { GradientSpan, H1, P2, P3 } from "../../components/theme/text/Headings";
import logoImg from "../../images/logo/v.png";

import {
  Blue,
  NeonGreen,
  OffWhite,
  Pink,
  White,
} from "../../components/theme/colors";

const DeleteMyData = () => {
  return (
    <div>
      <div
        style={{
          position: "relative",
          minHeight: "100vh",
          padding: "10vh 50px 100px 50px",
          backgroundColor: "#000",
          color: White,
        }}
      >
        {/* Centered logo */}
        <a className="text-decoration-none" href="https://www.vibecheckme.com">
          <img src={logoImg} alt="Vibe Check Logo" style={{ height: "50px" }} />
        </a>
        <H1 className="mt-10" color={White}>
          <GradientSpan $background={NeonGreen} $transitionBackground={Blue}>
            Delete My Data
          </GradientSpan>{" "}
        </H1>
        <P2 color={White} className="mt-10">
          Effective Date: June 1st, 2025
        </P2>
        <P2 color={White} className="mt-30">
          At Vibe Check, we respect your privacy and your right to control your
          personal data. If you would like to request deletion of your account
          and all associated data, please follow the instructions below.
        </P2>

        <H1 className="mt-50">How to Request Data Deletion</H1>
        <P2 color={White} className="mt-10">
          To delete your Vibe Check account and all personal information stored
          with us:
          <ul>
            <li>
              Email us at <strong>support@vibecheckme.com</strong> from the
              email address or phone number associated with your account.
            </li>
            <li>Include "Delete My Data Request" in the subject line.</li>
            <li>
              In the body of the email, confirm that you want all data,
              including quiz responses and account details, to be permanently
              deleted.
            </li>
          </ul>
        </P2>

        <H1 className="mt-50">What Happens Next</H1>
        <P2 color={White} className="mt-10">
          Once we receive your request, we will verify your identity and process
          the deletion within 30 days, in accordance with applicable privacy
          laws (e.g., GDPR, CCPA). You will receive a confirmation email when
          your data has been deleted.
        </P2>

        <H1 className="mt-50">Important Notes</H1>
        <P2 color={White} className="mt-10">
          <ul>
            <li>Data deletion is permanent and cannot be reversed.</li>
            <li>
              Some data may be retained if required by law or for legitimate
              business purposes (e.g., fraud prevention).
            </li>
          </ul>
        </P2>

        <H1 className="mt-50">Contact</H1>
        <P2 color={White} className="mt-10">
          For any questions about this process, contact us at
          <strong> support@vibecheckme.com</strong>.
        </P2>

        <div
          className="mt-100"
          style={{
            color: White,
            fontSize: "11px",
            textAlign: "center",
          }}
        >
          <P3 className="mb-20">
            Made by{" "}
            <GradientSpan $background={Blue} $transitionBackground={Pink}>
              Clickbait Labs, Inc.
            </GradientSpan>{" "}
          </P3>
          <a
            className="text-decoration-none mr-10"
            href="https://www.vibecheckme.com/terms-of-service"
            style={{
              color: OffWhite,
            }}
          >
            Terms of Service
          </a>{" "}
          <a
            className="text-decoration-none mr-10"
            href="https://www.vibecheckme.com/privacy-policy"
            style={{
              color: OffWhite,
            }}
          >
            Privacy Policy
          </a>{" "}
          <a
            className="text-decoration-none"
            href="https://www.vibecheckme.com/delete-my-data"
            style={{
              color: OffWhite,
            }}
          >
            Delete My Data
          </a>
        </div>
      </div>
    </div>
  );
};

export default DeleteMyData;
